import React, { useEffect, useRef, useState, useMemo } from 'react';
import cn from 'classnames';
import Styles from './screenSaver.module.scss';
import BatteryApi from './batteryApi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setScreenSaverStatus } from '@reducers/oauth';
import EventEmitter from '@utility/eventSubscribers';
import { setNotification } from '@reducers/notification';
import { getObjectValue } from '@utility/utills';

const ScreenSaver = ({ screenSaverStatus }) => {
  const OrderUp = useMemo(
    () =>
      JSON.parse(window.sessionStorage.getItem('deviceInfo'))?.deviceTypeId ===
      8,
    []
  );
  const deviceInfo = useMemo(
    () =>
      getObjectValue(() =>
        JSON.parse(window.sessionStorage.getItem('deviceInfo'), false)
      ),
    []
  );
  const isDriveThru = useMemo(
    () =>
      getObjectValue(
        () => [3].includes(deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );
  const isCallCenter = useMemo(
    () =>
      getObjectValue(
        () => [2].includes(deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );

  const Battery = new BatteryApi();
  const [showScreenSaver, setShowScreenSaver] = useState(0);
  const [error, setError] = useState(false);
  const [batteryLevel, setBatteryLevel] = useState(0);
  const [chargingStatus, setChargingStatus] = useState(false);
  const screenSaverId = useRef(null);
  const events = ['click', 'dblclick'];
  const successListener = () => {
    Battery.getPrototypes()
      .then(battery => {
        setShowScreenSaver(true);
        setBatteryLevel(battery.level * 100);
        setChargingStatus(battery.charging);
        battery.addEventListener(
          'levelchange',
          e => setBatteryLevel(e.currentTarget.level * 100),
          false
        );
        battery.addEventListener(
          'chargingchange',
          e => setChargingStatus(e.currentTarget.charging),
          false
        );
      })
      .catch(() => {
        setShowScreenSaver(true);
        setError(true);
      });
  };

  const removeListener = () => {
    clearTimeout(screenSaverId.current);
    if (['/checkIn'].includes(window.location.pathname)) {
      if (window.ReactNativeWebView) {
        EventEmitter.enableSideBar(true);
      }
    }
    Battery.getPrototypes()
      .then(battery => {
        setShowScreenSaver(false);
        setBatteryLevel(battery.level * 100);
        setChargingStatus(battery.charging);
        battery.removeEventListener(
          'levelchange',
          e => setBatteryLevel(e.currentTarget.level * 100),
          false
        );
        battery.removeEventListener(
          'chargingchange',
          e => setChargingStatus(e.currentTarget.charging),
          false
        );
      })
      .catch(() => {
        setShowScreenSaver(false);
        setError(true);
      });
  };

  const startScreenSaver = val => {
    screenSaverId.current = setTimeout(
      count => {
        if (count === 180) {
          clearTimeout(screenSaverId.current);
          if (window.ReactNativeWebView) {
            EventEmitter.enableSideBar(false);
          }
          successListener();
          return '';
        }
        return startScreenSaver(count + 1);
      },
      1000,
      val
    );
  };

  const displayBatterIcon = useMemo(() => {
    if (chargingStatus) {
      return (
        <div className="position-relative color-success">
          <i className="fas fa-battery-empty fa-rotate-270" />
          <i className={cn('fa fa-bolt fs-10', Styles.charging)} />
        </div>
      );
    }
    if (error) {
      return '';
    }
    switch (true) {
      case batteryLevel === 100:
        return (
          <i className="fas fa-battery-full color-success fa-rotate-270" />
        );
      case batteryLevel < 100 && batteryLevel > 50:
        return (
          <i className="fas fa-battery-three-quarters color-success fa-rotate-270" />
        );
      case batteryLevel === 50:
        return (
          <i className="fas fa-battery-half color-success fa-rotate-270" />
        );
      case batteryLevel < 50 && batteryLevel > 0:
        return (
          <i className="fas fa-battery-quarter color-warning fa-rotate-270" />
        );
      case batteryLevel === 0:
        return (
          <i className="fas fa-battery-empty color-danger fa-rotate-270" />
        );
      default:
        return '';
    }
  }, [chargingStatus, batteryLevel, error]);

  useEffect(() => {
    const screenSaverFn = () => {
      const screenSavertask = () => {
        if (screenSaverId.current || !screenSaverStatus) {
          removeListener();
        }
        if (screenSaverStatus) {
          startScreenSaver(0);
        }
      };
      setTimeout(screenSavertask, 0);
    };
    if (screenSaverId.current) {
      removeListener();
    }
    if (screenSaverStatus) {
      startScreenSaver(0);
    }

    events.forEach(event => {
      document.addEventListener(event, screenSaverFn);
    });
    return () => {
      if (screenSaverId.current) {
        clearTimeout(screenSaverId.current);
      }
      events.forEach(event => {
        document.removeEventListener(event, screenSaverFn);
      });
    };
  }, [screenSaverStatus]);
  return (
    <>
      {false && showScreenSaver && !OrderUp && !isDriveThru && !isCallCenter ? (
        <div
          className={cn(
            'd-flex flex-wrap align-content-center justify-content-center align-items-center fs-40 position-absolute w-100 bg-black color-white h-100',
            Styles.screenSaver
          )}
        >
          {/* <div className="fw-600">{Time} &nbsp;</div> */}
          <div className="fs-24">{displayBatterIcon}</div>
          {batteryLevel ? (
            <div className="fs-20">{Number(batteryLevel).toFixed(0)}%</div>
          ) : (
            ''
          )}
          {/* <div className="w-100 text-center">{Date}</div> */}
        </div>
      ) : (
        ''
      )}
    </>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setScreenSaverStatus,
      setNotification,
    },
    dispatch
  );

const mapStateToProps = state => ({
  loading: state.oauth.loading,
  screenSaverStatus: state.oauth.screenSaverStatus,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreenSaver);
